import React from 'react';
import PublicLayout from '../components/public/PublicLayout';

const Contact = () => {
  return (
    <PublicLayout>
      <h1>All Features</h1>
      <p>Detailed feature list coming soon...</p>
    </PublicLayout>
  );
};
export default Contact;